
export default {
    methods: {
        /**
         * @param {Progress} progress
         * @return {Boolean} true if given assignment is completed, false otherwise
         */
        isProgressFinished: function (progress) {
            return progress != null && (progress.finished != null || progress.fake)
        },

        /**
         * Automatically redirects to the last step available to the user
         * @param {Transition} transition, vue-router transition object
         * @param {Progress} progress
         */
        autoRedirectStep: function (progress) {

            if ( progress == null ) {
                console.error('No progress found')
                return this.$router.replace({ name: 'period' })
            }

            if ( this.stealthMode ) {

                // always redirect to the first step if teachers views assignment, don't worry about progress state
                if ( progress.fake ) {
                    this.$router.replace({ name: 'assignment.step', params: { assignmentId: progress.assignment, stepIdx: 1}})
                } else {
                    this.$router.replace({ name: 'assignment.overview', params: { assignmentId: progress.assignment }})
                }
                
                return
            }

            if ( this.isProgressFinished(progress) ) {
                this.$router.replace({ name: 'assignment.overview', params: { assignmentId: progress.assignment } })
            } else {
                // redirect to first step after last completed
                const assignment = this.$store.state.assignments.storage[ progress.assignment ]
                const stepIdx = Math.min(progress.step + 1, assignment.steps.length)
                this.$router.replace({ name: 'assignment.step', params: { assignmentId: progress.assignment, stepIdx: stepIdx } })
            }

        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/assignment/redirectMixin.js